var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgOtherNeutralSelected = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 105,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#other-neutral-selected_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 45,
  r: 24,
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 45,
  r: 18,
  fill: "#000",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 45,
  r: 20.5,
  stroke: "#000",
  strokeOpacity: 0.05,
  strokeWidth: 5
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M32 37v4l4-4h-4Zm12 0 4 4v-4h-4Zm4 16v-4l-4 4h4Zm-16 0h4l-4-4v4Zm15-8c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7 7-3.13 7-7Zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Z",
  fill: "#F7F7F9"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "other-neutral-selected_svg__a",
  x: 11,
  y: 20,
  width: 58,
  height: 58,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_3765_173379"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_3765_173379",
  result: "shape"
})))));

export { SvgOtherNeutralSelected as ReactComponent };
export default __webpack_public_path__ + "95612f7a73fe57ddf8bb8b7a5969da3e.svg";